import React, {useEffect, useState} from "react";
import '../../App.css';
import {
	PayPalScriptProvider,
	PayPalButtons,
	usePayPalScriptReducer
} from "@paypal/react-paypal-js";
// @ts-ignore
import { PayPalButtonsComponentProps } from "@paypal/paypal-js/types/components/buttons";
import {Colors} from "../../styles";
// keep options as any because the SDK types may differ between versions
const paypalScriptOptions: any = {
	"client-id": "AaVCcA-3Lsj2QCbs0NAeyCL7e960XT_Ydgb_FUysDbWLngkxo7tRdGxrVHXFYZtoSmkdD90IxvIKXO5w",
	currency: "USD",
};
const Button = ({order}: any) => {
	/**
	 * usePayPalScriptReducer use within PayPalScriptProvider
	 * isPending: not finished loading(default state)
	 * isResolved: successfully loaded
	 * isRejected: failed to load
	 */
	const [{ isPending }] = usePayPalScriptReducer();
	const paypalButtonTransactionProps: PayPalButtonsComponentProps = {
		style: { layout: "vertical" },
		createOrder(data: any, actions: { order: { create: (arg0: { purchase_units: { amount: { value: string; }; }[]; }) => any; }; }) {
			// @ts-ignore
			window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify(order));
			return actions.order.create({
				purchase_units: [
					{
						amount: {
							value: order.total,
						}
					}
				]
			});
		},
		onApprove: async (data: any, actions: { order: { capture: (arg0: {}) => Promise<{ payer: { name: { given_name: any; }; }; }>; }; }) => {
			/**
			 * data: {
			 *   orderID: string;
			 *   payerID: string;
			 *   paymentID: string | null;
			 *   billingToken: string | null;
			 *   facilitatorAccesstoken: string;
			 * }
			 */
			let order = await actions.order.capture({});
			// @ts-ignore
			window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify(order));
			return order;
		},
		onError(err: any) {
			let errObj = {
				err: err,
				status: "FAILED",
			};
			// @ts-ignore
			window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify(errObj));
		}
	};
	return (
		<>
			{isPending ? <h2>Load Smart Payment Button...</h2> : null}
						<PayPalButtons {...paypalButtonTransactionProps} />
		</>
	);
}
export const Payments = () =>  {
	const [order, setOrder] = useState({});

	useEffect(() => {
		const search = window.location.search;
		const query = new URLSearchParams(search).get("order");
		const order = JSON.parse(query!);

		setOrder(order);
		// @ts-ignore
		// window.ReactNativeWebView && window.ReactNativeWebView.postMessage(JSON.stringify(plan));

	}, []);
	return (
		<div style={styles.content} className="paymentButtons">
			<div style={styles.buttons}>
				<div style={styles.desc}>
					<h2
						style={styles.disclaimer}
						className="mt-6 text-3xl tracking-tight font-bold text-gray-900">
						Select payment mode:
					</h2>
					<p
						style={styles.disclaimer}
						className="mt-1 text-1xl tracking-tight text-gray-900">
						Change better choice to pay Filó combo cleaner
					</p>
				</div>
				<PayPalScriptProvider options={paypalScriptOptions}>
					<Button order={order}/>
				</PayPalScriptProvider>
			</div>
		</div>
	);
}

const styles = {
	content: {
		flex: 1,
		display: "flex",
		height: '100%',
		justifyContent: 'center',
		paddingTop: 50,
		backgroundColor: Colors.silver_light,
	},
	desc: {
		marginBottom: 30,
	},
	buttons:{
		width: 700,
	},
	disclaimer: {
		color: Colors.green_darker,
	},
}
